import { render, staticRenderFns } from "./ProductPricesChart.vue?vue&type=template&id=0b4bc532&"
import script from "./ProductPricesChart.vue?vue&type=script&lang=ts&"
export * from "./ProductPricesChart.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPricesChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports